// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"bf70b719","453":"6c0cdcaf"}[chunkId] + ".chunk.js";
};